'use strict';

angular.module('v-tv-package').component('vTvPackageGetLink', {
    controller: function controller(LZString, $log, $scope, $location, TvPackageSelectionStateService, ngDialog) {

        this.getLink = function () {
            var templateDataScope = $scope.$new();

            templateDataScope.selectionUrl = $location.absUrl();

            templateDataScope.selectAll = function ($event) {
                var el = $event.target;

                el.setSelectionRange(0, el.value.length);
            };

            return ngDialog.open({
                template: 'get-link-overlay',
                plain: false,
                className: 'v-ui-components ngdialog-theme-default v-dialog bg-color-white ',
                scope: templateDataScope
            });
        };
    },
    template:'<script type="text/ng-template" id="get-link-overlay"><p data-translate="SHARE.GET_LINK.DESCRIPTION"></p> <input ng-click="selectAll($event)" type="text" value="{{selectionUrl}}" readonly style="width:100%"></script><button type="button" data-ng-click="$ctrl.getLink()" data-translate="SHARE.GET_LINK.BTN_CAPTION"></button>'
});